import { IndexedArray } from '@common/types';
import { AnalyticsWidget } from '@common/types/dictionaries/analytics';

export const getDeletedWidgets = (widgets: IndexedArray<AnalyticsWidget>, deleted: boolean) => {
  const widgetsArray = Object.entries({ ...widgets });

  const filteredWidgets = [...widgetsArray].filter(([key, value]) => (deleted ? value.isDeleted : !value.isDeleted));
  return Object.fromEntries(filteredWidgets);
};
